import { SystemStory } from '@aclass/admin/storage/actions';
import { IAdminState } from '@aclass/admin/storage/states';
import { SystemNotification } from '@aclass/core/base/system.notification';
import { Response } from '@aclass/core/rest/response';
import { NgRedux } from '@angular-redux/store';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'adm-clear-cache',
    templateUrl: './clear-cache.component.html',
    styleUrls: [],
})
export class ClearCacheComponent implements OnInit {

    form: FormGroup;

    loading: boolean;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private http: HttpClient,
    ) {
    }

    /**
     * @inheritDoc
     */
    ngOnInit() {
        this.loading = false;
        this.form = new FormGroup({
            config: new FormControl(false),
            db: new FormControl(false),
            auth: new FormControl(false),
            search: new FormControl(true),
        });
    }

    runSave = () => {
        const tags = Object.entries(this.form.value).filter(([, v]) => v).map(([k]) => k);
        if (!tags.length) {
            this.ngRdx.dispatch(SystemStory.showNotification(SystemNotification.warning('Failed', 'No components were selected')));

            return;
        }
        this.loading = true;
        this.http.post('system/clear-cache', { tags }).subscribe(({ success }: Response<any>) => {
            this.loading = false;
            if (!success) {
                return;
            }
            this.ngRdx.dispatch(SystemStory.showNotification(SystemNotification.success('Success', 'Cache cleared')));
            this.form.reset({
                config: false,
                db: false,
                auth: false,
                search: true,
            });
        });
    }
}
